import { Badge, type BadgeVariant } from "@/components/Badge";
import { Text } from "@/components/Typography/Text";
import {
  PlaceStatus,
  type PlaceStatus as PlaceStatusType,
} from "@/constants/place";
import { defaultNS, useTranslation } from "@/lib/i18n";
import { match } from "ts-pattern";

type Props = {
  status: PlaceStatusType;
};

/**
 * Place のステータス表現の統一のためのコンポーネント
 */
export function PlaceStatusBadge({ status }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.places.shared.status",
  });
  const statusLabel = t(status);

  const variant = match(status)
    .with(PlaceStatus.CLOSED, () => "neutralMuted" as const)
    .with(PlaceStatus.PLANNED, () => "mutedWarning" as const)
    .otherwise(() => "secondaryMuted" as const) satisfies BadgeVariant;

  return (
    <Badge variant={variant} className="w-fit">
      <Text className="text-inverse" variant="labelSmall">
        {statusLabel}
      </Text>
    </Badge>
  );
}
